// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dark .modal-product-details {
    background-color: var(--dark-background);
}

.search-input-prd .MuiAutocomplete-endAdornment {
    display: none !important;
}`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/posnavbar/components/productDetail/index.css"],"names":[],"mappings":"AAAA;IACI,wCAAwC;AAC5C;;AAEA;IACI,wBAAwB;AAC5B","sourcesContent":[".dark .modal-product-details {\n    background-color: var(--dark-background);\n}\n\n.search-input-prd .MuiAutocomplete-endAdornment {\n    display: none !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
